import { useMutation } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';
import { answerAuditInvitation } from '../../api/answerAuditInvitation';
import { useBrowsePageStore } from './useBrowsePageStore';
import { getMessageFromError } from '@/core';

export const useAnswerAuditInvitationMutation = () => {
  const { enqueueSnackbar } = useSnackbar();
  const browseViewPageStore = useBrowsePageStore();

  return useMutation({
    mutationFn: answerAuditInvitation,
    onSuccess: () => {
      browseViewPageStore.setModalState('hidden');
      browseViewPageStore.setAuditInvitation(null);
      browseViewPageStore.browseViewRef?.current?.reset();
    },
    onError: (error: Error) => {
      enqueueSnackbar(getMessageFromError(error), { variant: 'error' });
    },
  });
};
